<template>
  <div>
    <!-- <div class="block news dark">
      <div class="newsletter dark">
        <b-row>
          <b-col class="align-right center-sm">
            <span>Get Notified of hottest deals
              <br>
              <input type="text" class="input" v-model="subscriptionEmail">
            </span>
          </b-col>
          <b-col class="align-left center-sm">
            <b-button
              class="subscribe-button veniqa-button dark"
              @click="subscribeClicked()"
            >Subscribe</b-button>
          </b-col>
        </b-row>
      </div>
    </div>-->
    <div class="block light">
      <div class="main-block">
        <b-row>
          <b-col class="align-left center-sm" md="4">
            <a href="#" @click="navigate('privacy-policy')">
              {{ $t('footer.privacyPolicy') }}
            </a>
            <br>
            <a href="#" @click="navigate('terms-conditions')">
              {{ $t('footer.termsAndConditions') }}
            </a>
          </b-col>
          <b-col md="4">@ {{ getLastUpdate() }}, {{brandingData.brand}}</b-col>
          <b-col class="align-right center-sm" md="4">
            <SocialMedia class="d-inline-flex flex-row" />
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import SocialMedia from '@/components/SocialMedia.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Footer',
  
  components: {
    SocialMedia,
  },

  data() {
    return {
      subscriptionEmail: '',
    };
  },

  methods: {
    getLastUpdate() {
      const options = { year: 'numeric', month: 'short' };
      const date = new Date(this.lastUpdate);
      const language = navigator.language || 'es-ES'; // Set es lang as default if user lang isnt found
      return date.toLocaleDateString(language, options);
    },

    navigate(path) {
      this.$router.push({ path: `/${path}` });
    },
  },

  computed: {
    ...mapGetters({
      brandingData: 'siteDataStore/brandingData',
      lastUpdate: 'siteDataStore/lastUpdateData'
    }),
  }
};
</script>

<style scoped lang="scss">
@import '../assets/css/constants.scss';

.block {
  height: 250px;
  padding: 10px 0px;
  // margin: 10px 0px;

  line-height: 250px;

  span,
  .main-block {
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
    width: 80%;
  }

  @media (max-width: 768px) {
    line-height: normal;
    .center-sm {
      text-align: center;
      margin: 15px 0px;
    }

    padding-top: 50px;
  }

  .newsletter {
    font-size: large;

    .input {
      width: 300px;
    }

    .subscribe-button {
      width: 220px;
      height: 60px;
      margin: 10px 0px;
    }
  }

  &.dark {
    background-color: $pitch-black;
    color: white;
  }

  .light {
    color: $pitch-black;
  }
}
</style>
